(function ($) {
  DJ.addBehavior('controlAccessibility', '.control-bar-accessibility-buttons', {
    attach: function () {
      const container = this;
      const buttonIncrease = container.querySelector('.control-bar-accessibility-buttons__increase');
      const buttonDecrease = container.querySelector('.control-bar-accessibility-buttons__decrease');
      const buttonReset = container.querySelector('.control-bar-accessibility-buttons__reset');
      const localStorageFontSize = localStorage.getItem('article-font-size');
      const blocksToChangeFontSize = document.querySelectorAll('.js-control-accessibility-font-change, .paragraph--type--cta-link');
      let blocksToChangeFontSizeArr = [];

      if (blocksToChangeFontSize) {
        // create an array to be able to use forEach in IE.
        blocksToChangeFontSizeArr = Array.prototype.slice.call(blocksToChangeFontSize);
      }

      /**
       * Change font-size for blocks with class 'js-control-accessibility-font-change'.
       * @param methodType
       *   Type of method to use - increase/decrease/reset font-size,
       *   or set from a local storage (localStorage).
       */
      const changeFontSize = (methodType) => {
        if (blocksToChangeFontSizeArr) {
          blocksToChangeFontSizeArr.forEach((block) => {
            const currentBlock = block;
            const currentFontSize = window.getComputedStyle(currentBlock, null).getPropertyValue('font-size');
            const parsedCurrentFontSize = parseFloat(currentFontSize);
            const increaseSize = parsedCurrentFontSize + 4.5;
            const decreaseSize = parsedCurrentFontSize - 4.5;

            switch (true) {
              case methodType === 'increase' && parsedCurrentFontSize <= 31:
                currentBlock.style.fontSize = `${increaseSize}px`;
                localStorage.setItem('article-font-size', increaseSize);
                break;
              case methodType === 'decrease' && parsedCurrentFontSize >= 10:
                currentBlock.style.fontSize = `${decreaseSize}px`;
                localStorage.setItem('article-font-size', decreaseSize);
                break;
              case methodType === 'localStorage':
                currentBlock.style.fontSize = `${localStorageFontSize}px`;
                break;
              case methodType === 'reset':
                currentBlock.style.fontSize = '';
                localStorage.removeItem('article-font-size');
                break;
              default:
            }
          });
        }
      };


      if (localStorageFontSize && blocksToChangeFontSizeArr) {
        changeFontSize('localStorage');
      }

      if (buttonIncrease) {
        buttonIncrease.addEventListener('click', () => {
          changeFontSize('increase');
        });
      }

      if (buttonDecrease) {
        buttonDecrease.addEventListener('click', () => {
          changeFontSize('decrease');
        });
      }

      if (buttonReset) {
        buttonReset.addEventListener('click', () => {
          changeFontSize('reset');
        });
      }
    }
  });
})(jQuery);
